import * as React from 'react';
import { reduxForm, getFormSyncErrors } from 'redux-form';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { ErrorSummary, Modal, Button } from 'components';
import * as c from 'models/constants';
import { requestFailure } from 'redux/modules/image';
import { Dispatch } from 'react-redux';
import { closeModal } from 'redux/modules/modal';
import { IServiceGroup, IServiceTree } from 'models/shop/serviceGroups';
import { keyToServiceCategory } from 'redux/modules/shop/serviceGroups/helpers';
import { IShopBookingTemplates } from 'models/shop/shopBookingTemplates';
import { IServiceCategoryDomainValue } from 'models/common';
import { formatCurrency, formatDuration } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';
import { Field } from 'redux-form';
import { BookingInputField } from 'components/FormControls';
import { required } from 'helpers/validationattributes';
import { groupBy } from 'containers/Shop/Helpers';

interface IOwnProps {
	officeId: string;
	servicesFormData: any;
	serviceCategories: IServiceCategoryDomainValue[];
	serviceCategory?: any;
	serviceGroups: IServiceGroup[];
	bookingTemplates: IShopBookingTemplates;
	serviceGroupData?: IServiceTree | any;
	selectedServices: string[];
	shopTypes: any;
	currencyKey: number;
	mode: 'add' | 'edit';

	// function props
	t: any;
	handleServicesSelected: (serviceIds: string[]) => void;
}

interface IProps extends IOwnProps, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {}

interface IState {
	checkedServices: string[];
	serviceGroupsToggled: string[];
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AddServicesToBundleForm extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			checkedServices: [],
			serviceGroupsToggled: [],
		};

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleServiceClick = this.handleServiceClick.bind(this);
		this.renderServicesSelect = this.renderServicesSelect.bind(this);
		this.toggleServiceGroup = this.toggleServiceGroup.bind(this);
	}

	public componentDidMount() {
		// Set checkedServices on load from parent component if previously set
		if (this.props.selectedServices?.length) {
			this.setState({ checkedServices: this.props.selectedServices });
		}
	}

	public handleSubmit() {
		if (this.props.mode === 'add') {
			this.props.handleServicesSelected(this.state.checkedServices);
		} else if (this.props.mode === 'edit') {
			this.props.handleServicesSelected(this.state.checkedServices);
		}
		this.props.closeModal();
	}

	private mapErrorKeyToMessage(key: string) {
		switch (key) {
			default:
				return key;
		}
	}

	get validServiceCategories() {
		const { serviceCategories, shopTypes, currentFormValues } = this.props;
		if (!serviceCategories?.length || !Array.isArray(shopTypes)) {
			return null;
		}
		const alreadyUsed = Object.keys(currentFormValues).map(keyToServiceCategory).filter(Boolean);
		// intersect
		return serviceCategories.filter(
			(sc) => alreadyUsed.includes(sc.key) || shopTypes.some((st) => sc.serviceCategoryShopTypes.includes(st)),
		);
	}

	private groupedServicesByGroup = () => {
		const { bookingTemplates } = this.props;
		return groupBy(bookingTemplates.services || [], 'serviceGroupId');
	};

	private groupedGroupsByParent = (serviceGroups: IServiceGroup[]) => {
		return groupBy(serviceGroups, 'parentId');
	};

	private groupedGroupsByCategory = () => {
		const { serviceGroups } = this.props;
		return groupBy(serviceGroups, 'serviceCategoryId');
	};

	private handleServiceClick = (serviceId: string) => {
		const tempCheckedServices = [...this.state.checkedServices];
		if (!tempCheckedServices.includes(serviceId)) {
			tempCheckedServices.push(serviceId);
		} else {
			const index = tempCheckedServices.indexOf(serviceId);
			tempCheckedServices.splice(index, 1);
		}
		this.setState({ checkedServices: tempCheckedServices });
	};

	private toggleServiceGroup = (serviceGroupId) => {
		const newServiceGroupsToggled = [...this.state.serviceGroupsToggled];

		if (newServiceGroupsToggled.includes(serviceGroupId) === false) {
			newServiceGroupsToggled.push(serviceGroupId);
		} else {
			const index = newServiceGroupsToggled.indexOf(serviceGroupId);
			newServiceGroupsToggled.splice(index, 1);
		}

		this.setState({ serviceGroupsToggled: newServiceGroupsToggled });
	};

	private renderServicesSelect = () => {
		const { t, currencyKey, currentFormValues } = this.props;

		// Group serviceGroups by parentId
		const groupedServices = this.groupedServicesByGroup();
		const groupedServiceByCategory = this.groupedGroupsByCategory();
		const serviceElements = [];

		let searchServiceName = null;

		if (Object.keys(currentFormValues).length > 0 && currentFormValues.serviceName) {
			searchServiceName = currentFormValues.serviceName.toLowerCase();
		}

		// Go through service categories
		Object.keys(groupedServiceByCategory).forEach((scKey) => {
			const groupedServiceGroups = this.groupedGroupsByParent(Object.values(groupedServiceByCategory[scKey]));
			const actualServiceGroups = groupedServiceGroups['null']; // service groups without parent id (services have parent ids)

			serviceElements.push(
				<div className="row" key={`sc${scKey}`}>
					<div className="col-12">
						<h2 className="addServicesToBundleModal__serviceCategoryTitle">{t(`DV_ServiceCategories_${scKey}`)}</h2>
					</div>
				</div>,
			);

			// Go through service groups (no parent id = serviceGroup, parent id = service)
			actualServiceGroups?.forEach((sg) => {
				const isServiceGroupToggled: boolean = this.state.serviceGroupsToggled.includes(sg.id);

				serviceElements.push(
					<div className="row" key={sg.id}>
						<div className="col-12">
							<div
								className="addServicesToBundleModal__serviceGroupNameContainer"
								onClick={() => this.toggleServiceGroup(sg.id)}
							>
								<h3 className="addServicesToBundleModal__serviceGroupNameContainer__title">{sg.value}</h3>
								{isServiceGroupToggled
									? renderIcon('arrow_right', 14, 14, 'addServicesToBundleModal__serviceGroupNameContainer__arrowDown')
									: renderIcon('arrow_right', 14, 14, 'addServicesToBundleModal__serviceGroupNameContainer__arrowUp')}
							</div>
						</div>
					</div>,
				);

				if (sg.id in groupedServiceGroups && isServiceGroupToggled === false) {
					groupedServiceGroups[sg.id]?.forEach((gsg) => {
						if (gsg.id in groupedServices) {
							// Group groupedServices also by variantParentId's (For showing main service name of subservices / variations)
							if (groupedServices[gsg.id].length > 1) {
								let filteredNumberOfServices: number = 0;

								// Hide main service name if none of it's subservices / variations were found
								if (searchServiceName !== null) {
									groupedServices[gsg.id].map((sgg) => {
										if (!sgg.name.toLowerCase().includes(searchServiceName)) {
											filteredNumberOfServices = filteredNumberOfServices + 1;
										}
									});
								}

								if (filteredNumberOfServices === 0) {
									serviceElements.push(
										<div className="row" key={gsg.id}>
											<div className="col-12">
												<div className="addServicesToBundleModal__mainServiceName">{gsg.value}</div>
											</div>
										</div>,
									);
								}
							}

							groupedServices[gsg.id]?.forEach((ser) => {
								// Hide bundles (will need to be changed in the future once we will use the cusotmData field for other stuff)
								if (!ser.customData) {
									// Display all / Display only the services that are searched for
									if (searchServiceName === null || ser.name.toLowerCase().includes(searchServiceName)) {
										serviceElements.push(
											<div
												className="row align-items-center addServicesToBundleModal__row"
												key={ser.id}
												onClick={() => this.handleServiceClick(ser.id)}
											>
												<div className="col-md-11 col-10">
													<div className="row">
														<div className="col-md-6 col-12">
															{groupedServices[gsg.id].length > 1 ? (
																<div className="addServicesToBundleModal__subserviceName">{ser.name}</div>
															) : (
																<div className="addServicesToBundleModal__serviceName">{ser.name}</div>
															)}
														</div>

														<div className="col-md-3 col-6">
															<div className="addServicesToBundleModal__duration">{formatDuration(ser.duration)}</div>
														</div>

														<div className="col-md-3 col-6">
															<div className="addServicesToBundleModal__price">
																{formatCurrency(currencyKey, ser.originalPrice)}
															</div>
														</div>
													</div>
												</div>

												<div className="col-md-1 col-2 d-flex justify-content-end">
													<div className="addServicesToBundleModal__price__checkContainer">
														{this.state.checkedServices.includes(ser.id)
															? renderIcon('checked')
															: renderIcon('unchecked')}
													</div>
												</div>
											</div>,
										);
									}
								}
							});
						}
					});
				}
			});
		});

		return <div className="container addServicesToBundleModal__container">{serviceElements}</div>;
	};

	public render() {
		const { formErrors, t } = this.props;

		const errorSummaryProps = {
			formErrors,
			mapErrorKeyToMessage: this.mapErrorKeyToMessage,
		};

		return (
			<Modal
				modalClass="modal-with-form add-edit-bundle-modal AddEditBundleModal addServicesToBundleModal"
				closeModal={this.props.closeModal}
				size="medium"
				showHeaderCloseButton={false}
			>
				<form autoComplete="off">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="addServicesToBundleModal__titleContainer">
									<h1 className="addServicesToBundleModal__title">{t('User_ShopCard_Services')}</h1>
									<div className="addServicesToBundleModal__closeButton" onClick={this.props.closeModal}>
										{renderIcon('cancel', 20, 20)}
									</div>
								</div>
								<div className="addServicesToBundleModal__subtext">{t('User_ShopCard_Services_AssignServices')}</div>
								<div className="addServicesToBundleModal__textField">
									<Field
										className="addServicesToBundleModal__textField__serviceName"
										name={'serviceName'}
										component={BookingInputField}
										type="text"
										label={'Search services'}
										validate={[required]}
										placeholder={'Search services'}
										customIconName={'search1'}
										customIconClassName={'servicesSearchIcon'}
									/>
								</div>
							</div>
						</div>
					</div>

					{this.renderServicesSelect()}

					<div className="addServicesToBundleModal__bottomContainer">
						<div className="container">
							<div className="row">
								<div className="col-12">
									<div className="addServicesToBundleModal__bottomContainer__buttons">
										<div className="addServicesToBundleModal__backButtonMobile" onClick={this.props.closeModal}>
											{renderIcon('arrow_left', 10, 10, 'addServicesToBundleModal__backButtonMobile__arrow')}
											<span className="addServicesToBundleModal__backButtonMobile__text">
												{t('BSPortal_Common_Back')}
											</span>
										</div>
										<Button className="addServicesToBundleModal__createButton" onClick={this.handleSubmit}>
											{t('User_ShopCard_Services_AddToBundle')}
										</Button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>

				<div>
					<ErrorSummary {...errorSummaryProps} />
				</div>
			</Modal>
		);
	}
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function mapStateToProps(state: IStore, _ownProps: IOwnProps) {
	let currentFormValues: { serviceName: string } = { serviceName: null };
	if (state.form[c.FORM_NAME_ADD_SERVICES_TO_BUNDLE] && state.form[c.FORM_NAME_ADD_SERVICES_TO_BUNDLE].values) {
		currentFormValues = state.form[c.FORM_NAME_ADD_SERVICES_TO_BUNDLE].values;
	}
	const initialValues: Partial<IServiceGroup> = {};

	return {
		manageShop: state.manageShop,
		state,
		currentFormValues,
		initialValues,
		formErrors: getFormSyncErrors(c.FORM_NAME_ADD_SERVICES_TO_BUNDLE)(state),
	};
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapDispatchToProps = (dispatch: Dispatch<IStore>, _ownProps: IOwnProps) => ({
	requestFailure: (error) => dispatch(requestFailure(error)),
	closeModal: () => dispatch(closeModal()),
});

let AddServicesToBundle = reduxForm(
	{
		form: c.FORM_NAME_ADD_SERVICES_TO_BUNDLE,
		destroyOnUnmount: true,
		enableReinitialize: true,
	},
	mapStateToProps,
)(AddServicesToBundleForm);

AddServicesToBundle = connect(mapStateToProps, mapDispatchToProps)(AddServicesToBundle);

export { AddServicesToBundle };
